/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { makeStyles } from '@mui/styles';

export const useFirewallSettingsStyles = makeStyles(theme => ({
  error: {
    color: `${theme.palette.error.main} !important`,
  },
  hint: {
    fontSize: '12px',
    lineHeight: '16px',
    color: 'rgba(0,0,0,0.6)',
    paddingLeft: '5px',
  },
  fields: {
    marginLeft: '5px',
  },
  field: {
    marginTop: '10px',
    display: 'flex',
    gap: '5px',
  },
  helperText: {
    '& .MuiFormHelperText-root': {
      padding: '0 0 0 5px',
    },
  },
}));
